// web/src/api/session.ts
//
// Centralizes how the API client gets the current JWT and active org id.
// Both come from the Supabase session + localStorage; abstracting them
// here means the client doesn't have to know about either.
import { supabase } from "../lib/supabase";

const ACTIVE_ORG_ID_KEY = "active_org_id";

export async function getAccessToken(): Promise<string | null> {
  const { data } = await supabase.auth.getSession();
  return data.session?.access_token ?? null;
}

export async function refreshSession(): Promise<string | null> {
  const { data } = await supabase.auth.refreshSession();
  return data.session?.access_token ?? null;
}

export function getActiveOrgId(): string | null {
  return localStorage.getItem(ACTIVE_ORG_ID_KEY);
}

export function setActiveOrgId(orgId: string): void {
  localStorage.setItem(ACTIVE_ORG_ID_KEY, orgId);
}

export function clearActiveOrgId(): void {
  localStorage.removeItem(ACTIVE_ORG_ID_KEY);
}
